import React from 'react';
import { Alert as AntdAlert } from 'antd-v5';
import PropTypes from 'prop-types';
/**
 * When you need to show alert messages to users.
 * When you need a persistent static container which is closable by user actions.
 * @returns
 */
export default function Alert({ onClose, onAfterClose, ...props }) {
  const [visible, setVisible] = React.useState(props.visible);

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleAfterClose = () => {
    if (onAfterClose) {
      onAfterClose();
    } else {
      setVisible(false);
    }
  };

  React.useEffect(() => {
    setVisible(props.visible);
  }, [props.visible]);

  return visible && <AntdAlert {...props} onClose={handleClose} onAfterClose={handleAfterClose} />;
}

Alert.propTypes = {
  type: PropTypes.oneOfType(['success', 'info', 'warning', 'error']),
  onClose: PropTypes.func,
  action: PropTypes.node,
  banner: PropTypes.bool,
  closable: PropTypes.bool,
  closeText: PropTypes.node,
  closeIcon: PropTypes.node,
  description: PropTypes.node,
  icon: PropTypes.node,
  message: PropTypes.node,
  showIcon: PropTypes.bool,
  visible: PropTypes.bool,
  onAfterClose: PropTypes.func,
};

Alert.defaultProps = {
  type: 'success',
  onClose: null,
  action: null,
  banner: false,
  closable: true,
  closeText: null,
  closeIcon: null,
  description: null,
  icon: null,
  message: null,
  showIcon: false,
  visible: false,
  onAfterClose: null,
};
